import { Helmet } from "react-helmet";
import SelectPackage from "../components/AiHomePage/SelectPackage";
import BannerSection from "../components/YouTubeThumbnailHome/BannerSection";
import FeaturesSection from "../components/YouTubeThumbnailHome/FeaturesSection";
import AboutSection from "../components/YouTubeThumbnailHome/AboutSection";
import ContactSection from "../components/YouTubeThumbnailHome/ContactSection";
import TestimonialSection from "../components/YouTubeThumbnailHome/TestimonialSection";


const Home = () => {
  return (
    <main>
      <Helmet>
        <title>Complete SEO Service for Small Business - Grow Your Business</title>
        <meta
          name="description"
          content="Use our proven cold email templates to attract clients, boost replies, and close more deals. Save time and win more clients with confidence."
        />
        <meta
          name="keywords"
          content="cold email templates, proven email templates, high-converting emails, email marketing templates, client outreach emails, business email templates, cold email examples, email campaign templates, B2B email templates, sales email templates, email marketing strategies"
        />
        <meta
          property="og:title"
          content="Proven SEO Checklist Excel for WordPress, Shopify & eCommerce "
        />
        <meta
          property="og:description"
          content="Use our proven cold email templates to attract clients, boost replies, and close more deals. Save time and win more clients with confidence."
        />
      </Helmet>
      <BannerSection />
      <FeaturesSection />
      <AboutSection />
      <SelectPackage />
      <TestimonialSection></TestimonialSection>
    </main>
  );
};

export default Home;
